import { AgentData_V10 } from '@dopomogai/types';
import { testScenarios } from './test-scenario-loader';

export interface FundingAgentCardData {
  id: string;
  slug: string;
  name: string;
  tagline: string;
  visual: any; // Simplified for this example
  creatorName: string;
  fundingGoalUSD: number;
  pledgedAmountUSD: number;
  supporterCount: number;
  communityAllocation: number;
}

/**
 * Loads all agent scenarios, de-duplicates them, filters for those with active crowdfunding,
 * and transforms them into the format required by the FundingAgentCard.
 */
export const loadFundingAgents = async (): Promise<FundingAgentCardData[]> => {
  try {
    // 1. Fetch all agent JSON files
    const agentPromises = testScenarios.map(scenario =>
      fetch(`/data/agentTestScenarios/${scenario.dataFileName}`)
        .then(res => res.json())
        .catch(error => {
          console.error(`Failed to load or parse ${scenario.dataFileName}:`, error);
          return null;
        })
    );

    const allAgentsData = (await Promise.all(agentPromises)).filter(Boolean) as AgentData_V10[];

    // 2. De-duplication Logic (copied from marketplaceLoader)
    const uniqueAgentsMap = new Map<string, AgentData_V10>(
      allAgentsData.map(agent => [agent.id, agent])
    );
    const uniqueAgentsList = Array.from(uniqueAgentsMap.values());

    console.log(`Funding loader: Loaded ${allAgentsData.length} agents, found ${uniqueAgentsList.length} unique agents.`);

    // 3. Filter and Transform the de-duplicated list
    const fundingAgents = uniqueAgentsList
      .filter(agent =>
        agent.crowdfundingDetails?.isActive === true &&
        agent.crowdfundingDetails.pledgePhaseData
      )
      .map(agent => {
        const pledgeData = agent.crowdfundingDetails!.pledgePhaseData!;
        
        return {
          id: agent.id,
          slug: agent.id,
          name: agent.name,
          tagline: agent.tagline,
          visual: agent.heroVisual, 
          creatorName: agent.creatorName || 'Anonymous Creator',
          fundingGoalUSD: pledgeData.progressTracker.pranaiGoalAmount || 0,
          pledgedAmountUSD: pledgeData.progressTracker.pledgedPranaiAmount,
          supporterCount: pledgeData.progressTracker.supporterCount,
          communityAllocation: agent.crowdfundingDetails!.communityAllocation || 40,
        };
      });

    return fundingAgents;

  } catch (error) {
    console.error("Fatal error in loadFundingAgents:", error);
    return [];
  }
};